<script>
  import { formatMoney, ignore, makeWebsiteRequest, withTax } from '../../Common/tools';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import Slider from '../../Common/Slider.svelte';
  import ConfirmAddon from './ConfirmAddon.svelte';
  import { disableAddon, LABELS } from './addons';
  import { fly } from 'svelte/transition';

  export let onChange = ignore, onCanceled = ignore, addon, subscription;

  let labels = LABELS;
  let initialValue = addon.value;
  let value = addon.value;
  let currency = subscription.currency;
  let taxRate = subscription.activeVatPercent;
  let enterManually = false;
  let confirming = false;

  let disable = async () => {
    let result = await disableAddon(addon);
    if (result) {
      onChange(result);
    }
  };

  onMount(() => {
    if (value > 10) {
      enterManually = true;
    }
  });
</script>

<div class="popup-widget-wrapper" style="overflow-x: hidden">
  <div class="col20 f-left t-left flex align-center flex-col">
    <h2 class="col20 f-left mt-15 t-center big-title-popup">{labels[addon.type]?.title}</h2>
    <div class="col12 f-left t-center mt-10 light-gray-text f-14-regular">{labels[addon.type]?.description}</div>
  </div>

  {#if confirming}
    <div class="col20 f-left" in:fly={{x: '100%'}}>
      <ConfirmAddon {addon} {currency} {value} {taxRate}
                    on:cancel={() => confirming = false}
                    on:confirm={(event) => onChange(event.detail)} />
    </div>
  {:else}
    <div class="col20 f-left" in:fly={{x: '-100%'}}>
      <div class="price-tables-wrapper table-of-one style-1 layout-2 col20 f-left mt-15">

        <div class="price-table most-popular highlight-table">
          <div class="price-table-inner">

            {#if enterManually}
              <div class="popup-input-wrapper f-left">
                <div class="info">
                  <h5>{M.QUANTITY}</h5>
                </div>
                <div class="input-wrapper">
                  <input type="number" min={1} step={1} bind:value={value} class="focus transition-border">
                </div>
              </div>
            {/if}

            <div class="col20 f-left mb-5 t-left f-14-regular">{labels[addon.type]?.summary(value)}</div>
            {#if !enterManually}
              <Slider bind:value={value} min={1} max={10} showValue={false} clz="inline-ui-slider mb-0" />
            {/if}
            {#if !enterManually && value === 10}
              <a class="col20 f-left mt-5 t-left f-14-regular text-link-hover" on:click={() => enterManually = true}>{M.NEED_MORE}</a>
            {/if}

            <h3 class="price-table-value monthly mt-15">
              {@html formatMoney(withTax(value * addon.monthlyPrice, taxRate), currency, true, true)}<span class="price-table-period">/{M.MONTH}</span>
              <span class="col20 f-left mt-5 price-table-support-text">
                <b>
                {value}
                  x {formatMoney(addon.monthlyPrice, currency, false, true)}/{M.MONTH}
                  {taxRate > 0 ? M.TAX_PLUS : ''}
                </b>
              </span>
            </h3>
            <div class="price-table-footer">
              {#if value === initialValue}
                <a class="price-table-button disabled">
                  {M.YOUR_CURRENT_LIMIT}
                </a>
              {:else}
                <a class="price-table-button" on:click={() => confirming = true}>
                  {value > initialValue ? M.UPGRADE : M.CHANGE}
                  <svg xmlns="http://www.w3.org/2000/svg" class="price-table-arrow" height="48" viewBox="0 -960 960 960" width="48">
                    <path
                      d="m695.461-314.463-32.615-31.999 109.847-110.231H140.001v-45.383h633.692L663.462-611.923l31.614-31.999 164.923 164.537-164.538 164.922Z"></path>
                  </svg>
                </a>
              {/if}
            </div>
          </div>
        </div>
      </div>
      <a class="col20 f-left t-center text-link-hover mt-15" on:click={disable}>{M.REMOVE_ADDON}</a>
    </div>
  {/if}
</div>
